import { render } from "./AddReturnPage.vue?vue&type=template&id=e49a0f24&ts=true"
import script from "./AddReturnPage.vue?vue&type=script&lang=ts"
export * from "./AddReturnPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__